export default __webpack_public_path__ + "static/media/tenis.59f9add6.png";